import { action, makeAutoObservable } from "mobx";
import moment from "moment";
import { PRINT_MEDIA_PAGE_SIZE } from "./print-media-settings";

export class PrintMediaStore {
    printMediaReport: any = null;
    currentReportId: any = 1;
    articles: any = {};
    currentPage = 1;
    printMediaFilters = {
        from_date: moment().subtract("days", 7),
        to_date: moment(),
        sources: [] as string[],
        lang: [] as string[],
        offset: null as number | null,
        count: null as number | null,
    };

    rootStore: any;

    constructor(rootStore: any) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
        this.initFilters();
        this.currentReportId = -1;
        this.articles = [];
    }

    initFilters() {
        this.printMediaFilters.from_date = moment().subtract("days", 7);
        this.printMediaFilters.to_date = moment();
        this.printMediaFilters.offset = 0;
        this.printMediaFilters.count = PRINT_MEDIA_PAGE_SIZE;
    }

    @action
    getAllSearchQueries = async () => {
        return await this.rootStore.api!.post("media/printmediaqueries/getallsearchqueries");
    };

    @action
    getPrintMediaReports = async (query: string, tags: Array<string>, limit: number, offset: number) => {
        return await this.rootStore.api!.post("media/printmediaqueries/getreports", { query, tags, limit, offset });
    };

    @action
    createNewPrintMediaReport = async () => {
        return await this.rootStore.api!.post("media/printmediaqueries/createnewreport", null);
    };

    @action
    viewPrintMediaReport = async (reportid: number | string) => {
        return await this.rootStore.api!.post("media/printmediaqueries/viewreport", { reportid });
    };

    @action
    updatePrintMediaReport = async (payload: Record<string, unknown>) => {
        return await this.rootStore.api!.post("media/printmediaqueries/updatereport", payload);
    };

    @action
    clonePrintMediaReport = async (reportid: number | string) => {
        return await this.rootStore.api!.post("media/printmediaqueries/clonereport", { reportid });
    };

    @action
    deletePrintMediaReport = async (reportid: number | string) => {
        return await this.rootStore.api!.post("media/printmediaqueries/deletereport", { reportid });
    };

    @action
    addNewSearchQuery = async (payload: Record<string, string>) => {
        if (payload["query"]?.trim() !== "" && payload["lang"]?.trim() !== "") {
            return await this.rootStore.api!.post("media/printmediaqueries/addsearchquery", payload);
        }
    };

    @action
    getArticles = async () => {
        if (this.currentReportId === -1) return;

        const response = await this.rootStore.api!.post("media/printmedia/articles", {
            reportid: this.currentReportId,
            offset: (this.printMediaFilters.count ?? 0) * (this.currentPage - 1),
            count: this.printMediaFilters.count,
            sources: this.printMediaFilters.sources,
            lang: this.printMediaFilters.lang,
            fromdate: this.printMediaFilters.from_date.format("YYYY-MM-DD"),
            todate: this.printMediaFilters.to_date.format("YYYY-MM-DD"),
        });
        this.articles = response.data;
    };

    @action
    setCurrentPage(newPage: number) {
        this.currentPage = newPage;
    }

    @action
    setPMReport = (payload: Record<string, unknown>) => {
        this.printMediaReport = payload;
        this.currentReportId = payload["id"];
    };

    @action
    setFilterDates = (from: moment.Moment, to: moment.Moment) => {
        this.printMediaFilters.from_date = from;
        this.printMediaFilters.to_date = to;
    };
}
